import { createBigDecimal } from '@0xtorch/big-decimal'
import { z } from 'zod'
import { responseDataSchema, successResponseSchema } from '../schema'

const depositSchema = z.object({
  /** Deposit address, e.g. "rNFugeoj3ZN8Wv6xhuLegUBBPXKCyWLRkB" */
  address: z.string(),
  /** Address remark. If there’s no remark, it is empty. When you withdraw from other platforms to the KuCoin, you need to fill in memo(tag). If you do not fill memo (tag), your deposit may not be available, please be cautious., "1919537769" */
  memo: z.string().nullable().optional(),
  /** Deposit amount, e.g. "20.50000000" */
  amount: z
    .string()
    .regex(/^\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  /** Fees charged for deposit, e.g. "0.00000000" */
  fee: z
    .string()
    .regex(/^\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  /** Currency, e.g. "XRP" */
  currency: z.string(),
  /** The chain of currency, e.g. "xrp" */
  chain: z.string(),
  /** Internal deposit or not */
  isInner: z.boolean(),
  /** Wallet Txid, e.g. "2C24A6D5B3E7D5B6AA6534025B9B107AC910309A98825BF5581E25BEC94AD83B" */
  walletTxId: z.string(),
  /** Status, e.g. "SUCCESS" */
  status: z.union([
    z.literal('PROCESSING'),
    z.literal('SUCCESS'),
    z.literal('FAILURE'),
  ]),
  /** remark, e.g. "Deposit" */
  remark: z.string().nullable().optional(),
  /** Creation time of the database record, e.g. 1666600519000 */
  createdAt: z.number().int(),
  /** Update time of the database record, e.g. 1666600549000 */
  updatedAt: z.number().int(),
})

export type Deposit = z.infer<typeof depositSchema>

export const depositResponseSchema = successResponseSchema.extend({
  data: responseDataSchema.extend({
    items: z.array(depositSchema),
  }),
})
